import React from "react";
import "./styles.scss";
import download from "../../Assets/download2.svg";

const PackageCard = ({
  title,
  description,
  version,
  date,
  handleClick,
  iconSrc,
}) => {
  const releaseDate = new Date(date);
  return (
    <div className="package_card">
      <div className="package_card_header">
        <span className="package_card_title">{title}</span>
        <div className="package_card_icon_wrapper">
          <img src={iconSrc} alt={title} />
        </div>
      </div>
      <span className="package_card_description">{description}</span>
      <div className="package_card_footer">
        <div className="package_card_btn">
          <div className="package_card_btn_icon">
            <img src={download} alt="download" />
          </div>
          <button onClick={handleClick}>Downloads</button>
        </div>
        {(version || date) && (
          <div className="package_card_footer_info">
            {version && (
              <>
                <span>Version : {version}</span>
                <span>|</span>
              </>
            )}
            {date && <span>{releaseDate.toISOString().split("T")[0]}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default PackageCard;
